import "./App.css";
import { Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import DynamicPage from "./pages/DynamicPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ContactPage from "./pages/ContactPage";
import ApplicationFormPage from "./pages/ApplicationFormPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import OfficeDetailPage from "./pages/OfficeDetailPage";
import GroupOfficesPage from "./pages/GroupOfficesPage";
import { Toaster } from "./components/ui/toaster";
import ErrorBoundary from "./components/ErrorBoundary";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <Suspense fallback={<div className="min-h-screen bg-white" />}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/apply" element={<ApplicationFormPage />} />
          <Route path="/news/:id" element={<NewsDetailPage />} />
          <Route path="/offices/group/:groupName" element={<GroupOfficesPage />} />
          <Route path="/offices/:officeId" element={<OfficeDetailPage />} />
          <Route path="/:path" element={<DynamicPage />} />
          <Route path="/:path/:subpath" element={<DynamicPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </Suspense>
      </ErrorBoundary>
      <Toaster />
    </div>
  );
}

export default App;
